module.exports = __webpack_public_path__ + "static/media/Headshot.09896bc9.jpg";